import {
  vBoolean,
  vInt,
  vMilitaryTimeStrict,
  vNumber,
  vObject,
  vOptional,
  vOptionalDef,
  vPipe,
  vString,
  vTransform,
} from '../../validation/index.ts'
import { vShipType } from '../ship-type.ts'

export const strictOpenDockHoursSchema = vPipe(
  vOptional(vMilitaryTimeStrict),
  vTransform(value => value || '08:00'),
)

export const strictCloseDockHoursSchema = vPipe(
  vOptional(vMilitaryTimeStrict),
  vTransform(value => value || '17:00'),
)

export const defaultFlagSchema = vOptionalDef(vBoolean(), false)

export const intSchema = vPipe(vNumber(), vInt())

export const shipTypeSchema = vShipType()

export type EntriesWithSuffix<T, Suffix extends string> = {
  [K in keyof T as K extends string ? `${K}${Suffix}` : never]: T[K]
}

export const UPLOAD_AUTO_SELECT_QUOTE_ENABLED = true
export const selectQuoteSchema = UPLOAD_AUTO_SELECT_QUOTE_ENABLED
  ? vObject({
      preferredCarrier: vOptional(vString()),
    })
  : vObject({})

export const createBOLSchema = vObject({
  createBOLFlag: vOptionalDef(vBoolean(), true),
})
export const schedulePickupSchema = vObject({
  schedulePickupFlag: vOptionalDef(vBoolean(), true),
})
